import {Observable} from 'rxjs/Observable';

// Classes.
import {RankingCategoryListBaseVD} from './ranking-category-list-base.vd';
import {ResponseData} from '../fetching/wa-response/wa-api-response';

// Providers.
import {LoggerService} from '../logger/logger-service';
import {DataFetchService} from '../wa-services/data-fetch-service';
import {DatabaseService} from '../wa-services/database-service';
import {FactoryService} from '../wa-services/factory-service';
import {WaHelperService} from '../wa-services/wa-helper-service';

// Interfaces.
import {LocatorInterface} from '../interfaces/locator.interface';


export class WorldRankingCategoryListVD extends RankingCategoryListBaseVD {

  constructor(
    logger: LoggerService,
    fetchSrvc: DataFetchService,
    db: DatabaseService,
    factory: FactoryService,
    _helper: WaHelperService,
    _locator: LocatorInterface
  ) {
    super(logger, fetchSrvc, db, factory, _helper, _locator);
  }

  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestWorldRankingCategories(this.locator, this.pageInfo());
  }
}
